<template>
    <div
        :class="
            twMerge(
                'relative',
                'text-[1rem]/[1.8] lg:text-[1.25rem]/[1.8]',
                '-ml-[var(--padding-base)] w-[calc(100%+var(--padding-base)*2)]',
                'sm:-ml-[var(--padding-sm)] sm:w-[calc(100%+var(--padding-sm)*2)]',
                'lg:ml-[initial] lg:w-[initial]',
                'before:absolute before:left-0 before:top-0 before:h-full before:w-[10%] before:bg-gradient-to-r before:from-base-bgGrey before:from-40% before:to-transparent',
                'after:absolute after:right-0 after:top-0 after:h-full after:w-[10%] after:bg-gradient-to-l after:from-base-bgGrey after:from-40% after:to-transparent',
                'before:lg:hidden after:lg:hidden',
            )
        "
    >
        <div
            :class="
                twMerge(
                    'px-[calc(var(--padding-base)+8px)] pb-3  sm:px-[calc(var(--padding-sm)+20px)] lg:px-5 lg:pb-[unset]',
                    'slt-scrollbar-hide overflow-x-auto',
                )
            "
        >
            <table class="min-w-[900px] table-auto lg:min-w-full">
                <slot />
            </table>
        </div>
    </div>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
</script>
